<template>
    <div class="l-wrap">
        <div class="l-constrained l-content proposal">
            <h1>New Quote</h1>

            <h2>Name</h2>
            <el-input v-model="name"></el-input>

            <h2>Employer</h2>
            <el-select
                v-model="employer"
                filterable
                clearable
                :trigger-on-focus="false"
                class="full-width"
                placeholder="Select an employer">
                <el-option
                    v-for="item in employers"
                    :key="`emp-${item.id}`"
                    :label="item.name + ' (' + item.id + ')' + (item.state !== 'Active' ? ` (${item.state})` : '')"
                    :value="item.id">
                </el-option>
            </el-select>

            <btn :cssClass="'btn btn btn-primary btn-lg'"
                 :icon="'fa-fw fas fa-check'"
                 style="margin-top: 20px;"
                 :click="() => saveQuote()">
                New Quote
            </btn>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'employers',
        'employer_id',
    ],
    data() {
        return {
            name: '',
            employer: this.employer_id,
        };
    },
    methods: {
        saveQuote() {
            return axios.post(url(`admin/quotes/create`), {
                name: this.name,
                employer: this.employer,
            }).then(response => {
                if (!response.data.quote_id) throw Error('Quote could not be created.');
                window.location.href = url(`admin/quotes/${response.data.quote_id}/detail`);
            });
        },
    },
};
</script>
